import 'slick-carousel/slick/slick.js';
// import 'jquery/dist/jquery.js';
// import './slick';

import BaseComponent from './BaseComponent';

import { match } from '../utilities/ResolutionHandler';

const debug = false;

export default class BaseCarouselSlick extends BaseComponent {
  get BASE_CONF() {
    return {
    };
  }

  constructor(element) {
    debug && console.log('BaseCarouselSlick');
    super(element);
    this.container = this.$options.container ? this.$el.closest(this.$options.container) : this.$el.parentNode;
    this.debounce = {};
    this.handleResizeScreen(element);
  }

  mount(element, options) {
    debug && console.log('BaseCarouselSlick mount', this.$el);

    // if($(element).closest('.js-wrapper-carousel-gallery').length){
      if (options.prevArrow && options.nextArrow) {
        // options.prevArrow = $(this.container).find('.gallery__arrow--left');
        // options.nextArrow = $(this.container).find('.gallery__arrow--right');
        options.prevArrow = $(this.container).find(options.prevArrow);
        options.nextArrow = $(this.container).find(options.nextArrow);
      }
    // }

    // let other components (eg: Spotlight) add event listeners (eg: init)
    setTimeout(() => $(element).slick({
      ...this.BASE_CONF,
      ...options
    }), 10);

    this.GRAB(this.CUSTOM_MESSAGES.CAROUSEL_EVENTS.goToSlide, (msg) => {
      const carousel = element.querySelector('.slick-slide.slick-current');
      if (carousel) {
        let currentSlideIndex = carousel.getAttribute('data-slick-index');

        if (parseInt( msg.slide) !== parseInt(currentSlideIndex) || msg.force) {
          // document.dispatchEvent(new Event('image-changes'));
          $(element).slick('slickGoTo', msg.slide);
        }
      }
    });

    // PITTI20-1277
    // this.updateData();
    $(element).on('init', (event, _) => {
        debug && console.log('BaseCarouselSlick init');

        this.refreshCurrentSlideOnImageLoad(_);

        // PITTI20-1277
        this.updateData();
    });

    /*
    $(element).on('lazyLoaded', () => {
        debug && console.log('BaseCarouselSlick lazyLoaded');

        document.dispatchEvent(new Event('image-changes'));
    });

    $(element).on('allImagesLoaded', () => {
        debug && console.log('BaseCarouselSlick allImagesLoaded');

        document.dispatchEvent(new Event('image-changes'));
    });
    */

    $(element).on('afterChange', (event, slick, currentSlide, nextSlide) => {
        debug && console.log('BaseCarouselSlick afterChange');

        // PITTI20-1277
        this.updateData();

        // PITTI20-1471
        // !this.refreshingCurrentSlide && document.dispatchEvent(new Event('image-changes'));
        !this.$options.autoplay && !this.refreshingCurrentSlide && document.dispatchEvent(new Event('image-changes'));

        var $countWrapper = this.container.querySelector('.js-gallery-count')
        if ($countWrapper) {
          var $currentIndex = $countWrapper.querySelector('.js-gallery-current-index');
          var $totoalCount = $countWrapper.querySelector('.js-gallery-total-count');
 
          $currentIndex.textContent = String(++currentSlide).padStart(2, '0');
          $totoalCount.textContent = String(slick.slideCount).padStart(2, '0');
        }   
    });
  }

  /**
   * When Slick is unslick in a breckpoint, does not restart
   * So on window resize
   * check if carousel is in a resolution where need to be active and reinit it 
   * [data-init-after-resize] show resolution where is needed
   */
  handleResizeScreen(element) {
    const reinitSize = element.dataset.initAfterResize;
    if (!reinitSize){return;}
  
    var currentSize;
   
    this.$on('resize.carousel', () => {
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }

      this.debounce = setTimeout(() => {
        if (!element.classList.contains('slick-initialized')){
          currentSize = this.getMediaQuery(currentSize);
          if(currentSize == reinitSize){
            this.mount(element, this.$options);
          }
        }
      }, 300);

    }, window);
  }

  getMediaQuery(currentSize){
    if (match('medium', 'small')) {
      currentSize = 'small';
    } else if (match('large', 'medium')) {
      currentSize = 'medium';
    } else if (match(null, 'large')) {
      currentSize = 'large';
    }
    return currentSize;
  }

  updateData() {
    debug && console.log('BaseCarouselSlick updateData');
    const carousel = this.container.querySelector('.js-update-data');

    // PITTI20-1277
    const currentSlide = carousel && carousel.querySelector('.slick-slide.slick-current');
    const currentImage = currentSlide && currentSlide.querySelector('.slide');
    if (currentImage) {
      const slides = carousel.querySelectorAll('.slide');
      let slidesNumber = ( slides.length - 2 ) / 2;
      slidesNumber = slidesNumber < 10 ? '0' + slidesNumber : slidesNumber;
  
      if (currentImage) {
        const imageIndex = currentImage.getAttribute('data-attribute-index')
        const imageSize = currentImage.getAttribute('data-attribute-imagesize');
        const imageCaption = currentImage.getAttribute('data-attribute-imagecaption');
        const imageSrc = currentImage.getAttribute('src');

        const slidesTotal = this.container.querySelector('.js-slides-total');
        const index = this.container.querySelector('.js-image-index')
        const size = this.container.querySelector('.js-image-size');
        const caption = this.container.querySelector('.js-image-caption');
        const download = this.container.querySelector('.js-image-download');

        index.innerHTML = (index && imageIndex) ? imageIndex : '';
        slidesTotal.innerHTML = (slidesTotal) ? slidesNumber : '';
        if(size) {
          size.innerHTML = (size && imageSize) ? imageSize : '';
        }
        caption.innerHTML = (caption && imageCaption) ? imageCaption : '';
        if (imageSrc && download) {
          download.setAttribute('href', currentImage.dataset.downloadUrl || imageSrc);
          download.setAttribute('download', currentImage.dataset.download);
        }
      }
    }

    //Focus on carousel update counter
    const carouselWithCounterArray = this.container.querySelectorAll('.js-carousel-with-counter');

    carouselWithCounterArray.forEach((carouselWithCounter) => {

      if (element === carouselWithCounter) {
        let carouselTotalSlideNumber = carouselWithCounter.querySelectorAll('.slick-slide').length;
        let carouselCurrentSlideNumber = $(carouselWithCounter).slick('slickCurrentSlide');

        carouselCurrentSlideNumber++;
  
        carouselCurrentSlideNumber = carouselCurrentSlideNumber < 10 ? '0' + carouselCurrentSlideNumber : carouselCurrentSlideNumber;
        carouselTotalSlideNumber = carouselTotalSlideNumber < 10 ? '0' + carouselTotalSlideNumber : carouselTotalSlideNumber;
  
        const currentCountElement = carouselWithCounter.parentElement.querySelector('.js-slide-current-number');
        const totalCountElement = carouselWithCounter.parentElement.querySelector('.js-slide-total');
  
        if(currentCountElement && totalCountElement) {
          currentCountElement.innerHTML = carouselCurrentSlideNumber;
          totalCountElement.innerHTML = carouselTotalSlideNumber;
        }
      }
    });
  }

  // PITTI20-1080 workaround for https://support.cloudinary.com/hc/en-us/community/posts/360042965232-Images-loaded-callback-
  refreshCurrentSlideOnImageLoad(_) {
    var self = this;
    var timeoutID;
    $('img', _.$slider).each(function() {
      this.onload = function() {
        debug && console.log('BaseCarouselSlick img onload');

        timeoutID && clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
          debug && console.log('BaseCarouselSlick changeSlide');

          self.refreshingCurrentSlide = true;
          _.changeSlide({
              data: {
                  message: 'index',
                  index: parseInt(_.currentSlide)
              }
          }, true);
          self.refreshingCurrentSlide = false;
        }, 250);
      };
    });
  }

}
